import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  menuName:'',
  active:1,
  navIndex:0,
  swiperFale:0,

}
const mutations = {
  swiperFaleTap(state, swiperFale){
    state.swiperFale = swiperFale;
  },
  saveActive(state, active){
    state.active = active;
  },
  saveNavIndex(state, navIndex){
    state.navIndex = navIndex;
  },
  saveMenuName(state, menuName){
    state.menuName = menuName;
  }
}

const getters = {
  active: state => state.active,
  navIndex: state => state.navIndex,
  swiperFale: state => state.swiperFale,
}
export default new Vuex.Store({
  state,
  getters,
  mutations,
})



// WEBPACK FOOTER //
// ./src/store/index.js